<template>
  <svg class="w-auto h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.17 47.01">
    <path class="a"
          d="M85.12,28.57H95.49a1.2,1.2,0,0,1,1.2,1.2V56.53a1.19,1.19,0,0,0,1.19,1.19h14.3A1.19,1.19,0,0,1,113.37,59l-.84,8.62a1.19,1.19,0,0,1-1.19,1.07H85.12a1.19,1.19,0,0,1-1.19-1.19V29.77A1.19,1.19,0,0,1,85.12,28.57Z"
          transform="translate(-83.93 -22.72)"/>
    <path class="a"
          d="M119.19,28.57h10.37a1.2,1.2,0,0,1,1.2,1.2V67.53a1.19,1.19,0,0,1-1.2,1.19H119.19A1.19,1.19,0,0,1,118,67.53V29.77A1.19,1.19,0,0,1,119.19,28.57Z"
          transform="translate(-83.93 -22.72)"/>
    <path class="b"
          d="M159.34,23.63l-6.61,26.82a1.19,1.19,0,0,1-2.32,0l-1.26-5.13a1.2,1.2,0,0,0-1.16-.91H137.62A1.19,1.19,0,0,0,136.48,46l6.6,21.92a1.19,1.19,0,0,0,1.14.85h14.31a1.18,1.18,0,0,0,1.14-.84L173,24.26a1.2,1.2,0,0,0-1.14-1.54H160.5A1.2,1.2,0,0,0,159.34,23.63Z"
          transform="translate(-83.93 -22.72)"/>
    <path class="a"
          d="M210,53.36a1.21,1.21,0,0,1,1.19,1.35,20.52,20.52,0,0,1-1.26,5.12A14.52,14.52,0,0,1,206.47,65a16.36,16.36,0,0,1-5.68,3.46,26.32,26.32,0,0,1-16.86-.26,15.8,15.8,0,0,1-6-4.24,17.3,17.3,0,0,1-3.55-6.52,28.4,28.4,0,0,1-1.15-8.35,29.73,29.73,0,0,1,1.15-8.49,18.53,18.53,0,0,1,3.55-6.83,16.68,16.68,0,0,1,6.24-4.55,22.58,22.58,0,0,1,9.08-1.66q8,0,12.14,3.76a17.07,17.07,0,0,1,5,9.43,1.19,1.19,0,0,1-1,1.45L199,43.36a1.2,1.2,0,0,1-1.27-.85c-.1-.35-.22-.7-.35-1v0a4.82,4.82,0,0,0-4-2.89,5.94,5.94,0,0,0-.73,0A5,5,0,0,0,188.1,41c-1,1.61-1.52,4.14-1.52,7.59a19.78,19.78,0,0,0,.54,5.2,8.21,8.21,0,0,0,1.43,3.12,4.32,4.32,0,0,0,2.08,1.51,7.06,7.06,0,0,0,2.42.4,5.18,5.18,0,0,0,3.71-1.32,6.5,6.5,0,0,0,1.61-3.12,1.19,1.19,0,0,1,1.16-1Z"
          transform="translate(-83.93 -22.72)"/>
    <path class="a"
          d="M230.61,54.23l-1.79,2.16a1.2,1.2,0,0,0-.27.76V67.53a1.19,1.19,0,0,1-1.2,1.19H217a1.19,1.19,0,0,1-1.19-1.19V29.77a1.19,1.19,0,0,1,1.19-1.2h10.37a1.2,1.2,0,0,1,1.2,1.2v8.7a1.19,1.19,0,0,0,2.12.74L238.76,29a1.2,1.2,0,0,1,.93-.45H250a1.2,1.2,0,0,1,.92,2L240.54,43a1.18,1.18,0,0,0-.13,1.34L253,67a1.19,1.19,0,0,1-1,1.77H240.8a1.18,1.18,0,0,1-1.06-.64l-7.15-13.64A1.2,1.2,0,0,0,230.61,54.23Z"
          transform="translate(-83.93 -22.72)"/>
  </svg>
</template>

<style scoped>
.a {
  fill: #0f192a;
}

.b {
  fill: #00e091;
}</style>